import React from 'react';
import { mingoOnImgError } from '../lib/placeholderImage';
import { profileAvatarSrc } from '../lib/profileAvatarSrc';

/**
 * 기본 프로필 이미지 — 그라데이션 원 + 이니셜
 * avatarUrl / emoji 가 있으면 해당 표시(선택)
 */
function DefaultAvatar({ name, size = 72, avatarUrl, emoji, className }) {
  const gid = React.useId().replace(/:/g, '');

  if (avatarUrl) {
    return (
      <img
        src={profileAvatarSrc(avatarUrl)}
        alt=""
        width={size}
        height={size}
        className={className}
        style={{ width: size, height: size, objectFit: 'cover', display: 'block', borderRadius: '50%' }}
        onError={mingoOnImgError}
      />
    );
  }
  if (emoji) {
    return (
      <div
        className={className}
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: Math.round(size * 0.45),
          background: 'rgba(255,255,255,0.25)',
        }}
        aria-hidden="true"
      >
        {emoji}
      </div>
    );
  }

  const initial = (name || 'M').trim().charAt(0).toUpperCase() || 'M';
  const gradId = `mingo-av-grad-${gid}`;

  return (
    <div className="mingo-default-avatar" style={{ width: size, height: size }} aria-hidden="true">
      <svg viewBox="0 0 72 72" width={size} height={size} className="mingo-default-avatar__svg">
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FFB347" />
            <stop offset="100%" stopColor="#FF6F0F" />
          </linearGradient>
        </defs>
        <circle cx="36" cy="36" r="36" fill={`url(#${gradId})`} />
        <text
          x="36"
          y="44"
          textAnchor="middle"
          fill="#fff"
          fontSize="30"
          fontWeight="800"
          fontFamily="system-ui, -apple-system, 'Segoe UI', sans-serif"
        >
          {initial}
        </text>
      </svg>
    </div>
  );
}

export default DefaultAvatar;
